import { render, staticRenderFns } from "./NotificationItem.vue?vue&type=template&id=685fce62&scoped=true&"
import script from "./NotificationItem.vue?vue&type=script&lang=js&"
export * from "./NotificationItem.vue?vue&type=script&lang=js&"
import style0 from "./NotificationItem.vue?vue&type=style&index=0&id=685fce62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685fce62",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/iy_web_test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('685fce62')) {
      api.createRecord('685fce62', component.options)
    } else {
      api.reload('685fce62', component.options)
    }
    module.hot.accept("./NotificationItem.vue?vue&type=template&id=685fce62&scoped=true&", function () {
      api.rerender('685fce62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Notification/NotificationItem.vue"
export default component.exports